export default "__VITE_ASSET__VLqCfuh1__"